import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {LinkContainer} from 'react-router-bootstrap'
import { Glyphicon, Button } from 'react-bootstrap'
import Logger from '../stores/Logger'

class Error extends Component {
    render() {
        const {stores} = this.props
        const {routingStore} = stores
        const {location} = routingStore
        Logger.trackEvent('500', 'page', location.pathname)

        return (
            <div style={{textAlign:"center"}}>
                <h1>500 - Error</h1>
                <div>Something went wrong, we are so sorry.</div>
                <div>We have taken a note of this, and will investigate as soon as possible.</div>

                <LinkContainer to='/ideas'>
                    <Button bsStyle='primary'>Go Back</Button>
                </LinkContainer>

                <div><em>Have a nice day!</em></div>
                <h1><Glyphicon glyph='thumbs-up'/></h1>
            </div>
        )
    }
}

export default inject("stores")(observer(Error))



// WEBPACK FOOTER //
// ./src/containers/Error.js